import { css } from "@emotion/react";

export const sectionMarginBottom = css`
  margin-bottom: 1.285714286rem;
`;
